import axios from 'axios'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { toast } from 'react-toastify'
import Header from '../components/Header'
import Navbar from '../components/Navbar'
import { TYPE_EXAM } from '../services/routes'
import Modal from 'react-modal'
import { Footer } from '../components/Footer';

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        minWidth: '500px',
        bottom: 'auto',
        marginRight: '-50%',
        backgroundColor: 'white',
        transform: 'translate(-50%, -50%)',
    },
};

const TypeExam = () => {

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('')
    const [exams, setExams] = useState([])
    const [details, setDetails] = useState()
    const [typeExamId, setTypeExamId] = useState('')
    const [textSearch, setTextSearch] = useState('')

    const [showPostModal, setShowPostModal] = useState(false)
    const [modalIsOpen, setIsOpen] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false)

    const token = localStorage.getItem('token')

    const getExams = () => {
        axios(TYPE_EXAM.GETALL, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(json => {
                console.log(json)
                setExams(json.data)
            })
    }

    function fn(text, count) {
        return text.slice(0, count) + (text.length > count ? "..." : "");
    }

    const getTypeExamId = async () => {
        let data
        if (typeExamId) {

            await axios.get(TYPE_EXAM.GET.replace(/:id/gi, typeExamId), {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => {
                    data = res.data.typeExam
                    console.log('typeExamId ', res.data.typeExam)
                    setTitle(data.title)
                    setDescription(data.description)

                    // setPatientData(res.data.patient)
                    // setPatientName(`${res.data.patient.name} ${res.data.patient.lastname}`)
                })
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (typeExamId) {
            await axios.put(TYPE_EXAM.UPDATE.replace(/:id/gi, typeExamId), {
                title,
                description,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => {
                    console.log(res)
                    toast.success('Tipo de exame atualizado')
                    setTypeExamId('')
                    setTitle('')
                    setDescription('')
                })
                .catch(err => {
                    console.log(err)
                    toast.error('Erro ao atualizar')
                })
            return;
        }

        await axios.post(`${TYPE_EXAM.CREATE}`, {
            title,
            description
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((json) => {
            toast.success('Adicionado novo tipo de exame!')
            getExams()
            console.log(json)
        }).catch(err => {
            console.error(err)
            toast.error('Título de exame já criado ou erro no servidor.')
        })
    }

    const togglePostModal = (item) => {
        setIsOpen(!modalIsOpen);
        setDetails(item)
        setShowPostModal(!showPostModal)
    }

    const toggleModalDelete = (item) => {
        setIsOpen(!modalIsOpen)
        setDetails(item)
        setShowModalDelete(!showModalDelete)
    }

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const deleteTypeExam = async (id) => {
        try {
            await axios.delete(`${TYPE_EXAM.REMOVE.replace(/:id/gi, id)}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                })
            toast.success('Tipo de exame deletado!')
            getExams()
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getTypeExamId()
    }, [typeExamId])

    useEffect(() => {

        getExams()

    }, [handleSubmit])

    return (
        <>
            <Helmet>
                <title>Adicionar exames - Coluço System</title>
            </Helmet>
            <div id="wrapper">

                {showPostModal && <Modal
                    ariaHideApp={false}
                    isOpen={modalIsOpen}
                    onRequestClose={togglePostModal}
                    style={customStyles}
                    contentLabel="Modal de Tipo de Exames"
                >
                    <button className="btn btn-danger float-right" onClick={togglePostModal}>Fechar</button>
                    <h2 className="mb-4">Informações do tipo</h2>

                    <b>Título:</b> {details.title} <br />
                    <b>Descrição:</b><br /> {details.description !== '' ? details.description : <span style={{ color: "red" }}>Sem descrição</span>} <br />
                </Modal>}

                {showModalDelete && <Modal
                    ariaHideApp={false}
                    isOpen={modalIsOpen}
                    onRequestClose={toggleModalDelete}
                    style={customStyles}
                    contentLabel="Modal de Deletar Tipo de Exame"
                >
                    <button className="btn btn-danger float-right" onClick={toggleModalDelete}>X</button>
                    <h2 className="mb-4">Deletar tipo de exame</h2>

                    <h5 className="align-center">Tem certeza que quer excluir este exame?</h5>

                    <div className="d-flex mt-5 mb-4 justify-content-center">
                        {console.log(details)}
                        <button className="me-3 btn btn-danger" onClick={async () => {
                            await deleteTypeExam(details._id)
                            toggleModalDelete()
                        }}>Excluir</button>
                        <button className="btn btn-primary" onClick={toggleModalDelete}>Fechar</button>
                    </div>

                </Modal>}

                <Header active="typeExam" />

                <div id="content-wrapper" className="d-flex flex-column">

                    <div id="content">

                        <Navbar />

                        <div className="container-fluid">

                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Adicionar um novo exame</h6>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-row">
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Título *</label>
                                                            <input type="text" value={title} onChange={e => setTitle(e.target.value)} className="form-control" placeholder="Nome do exame" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="col-md-8">
                                                        <div className="mb-3">
                                                            <label className="form-label">Descrição</label>
                                                            <textarea className="form-control" value={description} onChange={e => setDescription(e.target.value)} placeholder="Descrição" rows="3"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex mt-3">
                                            <button type="submit" className="btn btn-primary">{typeExamId ? 'Editar' : 'Cadastrar'}</button>
                                            {typeExamId ? (
                                                <button type="button" onClick={() => {
                                                    toast('Edição cancelada')
                                                    setTypeExamId('')
                                                    setTitle('')
                                                    setDescription('')
                                                }} className="btn ms-2 btn-danger">Cancelar edição</button>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <h1 className="h3 mb-2 text-gray-800">Exames adicionados</h1>

                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Lista dos tipo de exames</h6>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6" />
                                            <div className="col-sm-12 col-md-6">
                                                <div className="dataTables_filter text-right mb-2">
                                                    <input type="search" onChange={e => setTextSearch(e.target.value)} className="form-control" placeholder="Digite o título do exame" />
                                                </div>
                                            </div>
                                        </div>
                                        <table className="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>Título</th>
                                                    <th>Descrição</th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {exams.filter(item => {
                                                    if (textSearch === '') {
                                                        return item
                                                    }
                                                    else if (item.title.toLowerCase().includes(textSearch.toLowerCase())) {
                                                        return item
                                                    }
                                                }).map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.title}</td>
                                                            <td>{item.description !== '' ? fn(item.description, 40) : <span style={{ color: "red" }}>Sem descrição</span>}</td>
                                                            <td>
                                                                <button title="Detalhes" className="btn btn-secondary me-1" onClick={() => togglePostModal(item)}><i className="fas fa-info fa-fw"></i></button>
                                                                <button title="Editar" onClick={() => {
                                                                    toast('Edite no campo acima')
                                                                    scrollTop()
                                                                    setTypeExamId(item._id)
                                                                }} className="btn btn-success me-1" ><i className="fas fa-pen fa-fw "></i></button>
                                                                <button title="Excluir" className="btn btn-danger" onClick={() => toggleModalDelete(item)}><i className="fas fa-trash fa-fw"></i></button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    {exams.length <= 0 ?
                                        <div className="d-flex justify-content-center">
                                            <h6 className="">Não há outros tipos cadastrados</h6>
                                        </div>
                                        :
                                        ''
                                    }
                                </div>
                            </div>

                        </div>

                    </div>

                    <Footer />

                </div>

            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
        </>
    )
}

export default TypeExam
